
<div class="layout-container ">
    <div class="swiper-container">
     <div class="swiper-wrapper">
       <div class="swiper-slide" *ngFor="let img of images">
         <img [src]="img" alt="Slide image" />
       </div>
     </div>
 </div>
 <br>

<!-- VISION -->
  <div class="section">
    <div class="section-container">
      <div class="section-image">
        <img src="../../assets/vision.webp" alt="Vision Image" />
      </div>
      <div class="section-content">
        <h2 class="heading-lg">Vision</h2>
        <hr>
        <p class="text-block">
          To be a global leader in precision plastic manufacturing, setting the benchmark for accuracy,
          scalability, and innovation, while enabling our customers to deliver world-class products.
        </p>
      </div>
    </div>
  </div>

<!-- MISSION -->
  <div class="section">
    <div class="section-container">
    
      <div class="section-content">
        <h2 class="heading-lg">Mission</h2>
        <hr>
        <ul class="custom-bullet-list">
          <li *ngFor="let mission of aimMission" [innerHTML]="mission"></li>
        </ul>
      </div>
      <div class="section-image">
        <img src="../../assets/mission.webp" alt="Mission Image" />
      </div>
    </div>
  </div>

 <div class="heading-with-button">
   <h2 class="heading-lg">Prestigious Clients</h2>
   <button mat-flat-button class="all-button" (click)="goToClient()">+ All Clients</button>
 </div>
 <hr>
 
<div class="gallery-wrapper">
  <div class="image-gallery" *ngFor="let imag of clientImages">
    <app-image-gallery [images]="imag"></app-image-gallery>
  </div>
</div>
 
 </div>